"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingOptionInputStyle = exports.SortingOptionSpanStyle = exports.SortingOptioDivStyle = void 0;
var SortingOptioDivStyle = function (isOpaque) {
    return {
        backgroundColor: "white",
        marginTop: "26px",
        padding: "5px",
        "border-radius": "11px",
        opacity: isOpaque ? ".6" : "1",
    };
};
exports.SortingOptioDivStyle = SortingOptioDivStyle;
exports.SortingOptionSpanStyle = {
    "font-weight": "bold",
};
exports.SortingOptionInputStyle = {
    width: "fit-content",
    minWidth: "120px",
};
